// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { update, createOrUpdate, get } from "./operations.js";
export {
  VaultExtendedInfoUpdateOptionalParams,
  VaultExtendedInfoCreateOrUpdateOptionalParams,
  VaultExtendedInfoGetOptionalParams,
} from "./options.js";
